import React from "react";
import {BlinkBlur} from "react-loading-indicators";
import logolight from "../../assets/images/logo/logo-light-full.png";
const AppLoader = () => {
  return (
    <div className="app-loader">
      <img src={logolight} alt="aaMOBee" className="loader-logo" height={60} />

      <BlinkBlur color={["#0bb197", "#556ee6", "#0bb197"]} />

      <div className="loader-text"> Loading... </div>
    </div>
  );
};

export default AppLoader;